import { immerable, newFuid } from '@utils';

import type { IColor } from '@color';
import { BorderElementConfig } from './BorderElementConfig';
import {
  LayoutConfig,
  type CornerRadius,
  type ElementId,
  type ImageElementData,
  type TextElementData
} from './types';

export class ElementDecl {
  [immerable] = true;

  id: ElementId;
  layoutConfig: LayoutConfig = new LayoutConfig();
  backgroundColor?: IColor;
  cornerRadius: CornerRadius = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  };
  border: BorderElementConfig = new BorderElementConfig();
  parentId: ElementId | undefined;
  childIds: ElementId[] = [];
  textData?: TextElementData;
  imageData?: ImageElementData;

  // Visual enhancement properties
  hovered = false;
  isSelected = false;
  hasCopyOverlay = false;
  opacity = 1;
  clip = false;
  zIndex = 0;

  constructor() {
    this.id = newFuid() as unknown as ElementId;
  }

  get hasParent(): boolean {
    return this.parentId !== undefined;
  }

  get isRoot(): boolean {
    return this.parentId === undefined;
  }

  // Methods for maintaining relationships
  addChild(childId: ElementId): void {
    if (!this.childIds.includes(childId)) {
      this.childIds.push(childId);
    }
  }

  removeChild(childId: ElementId): void {
    const index = this.childIds.indexOf(childId);
    if (index !== -1) {
      this.childIds.splice(index, 1);
    }
  }

  get isText(): boolean {
    return this.textData !== undefined;
  }

  get isImage(): boolean {
    return this.imageData !== undefined;
  }
}
